// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Axios from 'axios';
import api from './request/api'
import * as echarts from 'echarts';
import resetMessage from "./assets/js/Message.js"
import moment from 'moment'
import {
    hex_md5
} from './assets/js/md5.js'
import Cookies from 'js-cookie'
import dataConver from './utils/convertData.js'

// import '@/assets/css/theme.less'; //引入换肤css


Vue.prototype.$moment = moment
Vue.prototype.$Cookies = Cookies
Vue.prototype.$Md5 = hex_md5
Vue.prototype.$message = resetMessage
Vue.prototype.$echarts = echarts
Vue.prototype.$api = api
Vue.prototype.$axios = Axios
Vue.config.productionTip = false
Vue.prototype.$dataConver = dataConver;
Vue.use(ElementUI);




router.beforeEach((to, from, next) => {
    let userToken = localStorage.getItem('token') ? true : false;
    const userPermissions = localStorage.getItem('userPermissions') ? JSON.parse(localStorage.getItem('userPermissions')) : ["首页"];

    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
        if (userToken) { // 判断本地是否存在token
            if (userPermissions.includes(to.meta.title) || to.meta.title == '用户详情') {
                next();
            } else {
                next({
                    path: '/main/index'
                });
                store.commit("setNavIndex", [0, 0]);
            }
        } else {
            next({
                path: '/Login'
            });
        }
    } else {
        next();
    }

    if (to.fullPath === '/Login' || to.fullPath === '/') {
        if (userToken) {
            next({
                path: from.fullPath
            });
        } else {
            next();
        }
    }
});





/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js